export function setAttr(el, attr, val) {
    if (val === false || val === undefined || val === null || val === '') {
        el.removeAttribute(attr);
    }
    else {
        el.setAttribute(attr, val === true ? attr : String(val));
    }
}
export function attr(el, attrs, val) {
    if (typeof attrs == 'string') {
        if (arguments.length == 2)
            return el.getAttribute(attrs);
        return setAttr(el, attrs, val);
    }
    for (var key in attrs)
        setAttr(el, key, attrs[key]);
}
//# sourceMappingURL=attr.mjs.map